import React, { useState } from 'react'
import { string, oneOf, func, node, object, bool } from 'prop-types'
import styled from 'styled-components'
import Link from './Link'
import Label from './Label'

import {
  suggestiveColor,
  primaryTextColor,
  headersColor,
  highlightColor,
  errorColor,
} from './colors'

const StyledContainer = styled.div`
  width: 100%;
  flex-direction: column;
`

const StyledFloatingLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  background-color: white;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 5px;
  height: 45px;
  width: 100%;
  transition: border 300ms ease-out;
  border: ${({ hasError }) =>
    `1px solid ${hasError ? errorColor : suggestiveColor}`};
`

const FloatingLabel = styled.label`
  padding: 0;
  margin: 0;
  border: 0;
  position: absolute;
  color: ${primaryTextColor};
  font-size: 14px;
  bottom: 0;
  transition: all 0.2s ease-in-out;
  transform-origin: left top;
  cursor: text;
  pointer-events: none;
  line-height: 45px;
  transform: ${({ active }) =>
    active ? 'translate3d(0, -9%, 0) scale(0.75)' : 'none'};
`

const StyledInput = styled.input`
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  color: ${headersColor};
  font-size: 14px;
  height: 35px;
`

const StyledRightComponent = styled.div`
  position: absolute;
  right: 15px;
  display: flex;
  align-items: center;
  height: 45px;
`

const SmallInput = ({
  label,
  name,
  value,
  error,
  htmlType,
  onChange,
  onBlur,
  style,
  RightComponent,
  labelActive = false,
  initiallyActive = false,
}) => {
  const [active, setActive] = useState(initiallyActive)
  const [showPassword, setShowPassword] = useState(false)

  const handleFocus = () => {
    setActive(true)
  }

  const handleBlur = (event) => {
    setActive(event.target.value.length !== 0)
  }

  const hasError = Boolean(error)
  const isPassword = htmlType === 'password'

  return (
    <StyledContainer style={style}>
      <StyledFloatingLabelContainer active={active} hasError={hasError}>
        <FloatingLabel active={labelActive || active}>{label}</FloatingLabel>
        <StyledInput
          name={name}
          type={showPassword ? 'text' : htmlType}
          onFocus={handleFocus}
          onBlur={(event) => {
            handleBlur(event)
            onBlur && onBlur(event)
          }}
          value={value}
          onChange={onChange}
        />
        {isPassword && (
          <StyledRightComponent onClick={() => setShowPassword(!showPassword)}>
            <Link
              label={showPassword ? 'Hide' : 'Show'}
              size={18}
              color={showPassword ? highlightColor : primaryTextColor}
            />
          </StyledRightComponent>
        )}
        {Boolean(RightComponent) && (
          <StyledRightComponent>{RightComponent}</StyledRightComponent>
        )}
      </StyledFloatingLabelContainer>
      {hasError && (
        <Label value={error} type="error" style={{ marginLeft: 2 }} />
      )}
    </StyledContainer>
  )
}

SmallInput.propTypes = {
  label: string.isRequired,
  // name: string.isRequired,
  error: string,
  value: string,
  htmlType: oneOf(['text', 'password']),
  onChange: func,
  onBlur: func,
  style: object,
  RightComponent: node,
  initiallyActive: bool,
}

export default SmallInput
